import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnrollmentComponent } from '../../portal/pages/enrollment/enrollment/enrollment.component';

@Component({
  selector: 'app-details-card',
  templateUrl: './details-card.component.html',
  styleUrls: ['./details-card.component.scss']
})
export class DetailsCardComponent implements OnInit {
  @Input() title: string;
  @Input() editPath: any; /// change type 

  constructor(private router: Router, private route: ActivatedRoute, private enrollmentComponent: EnrollmentComponent) { }

  ngOnInit() { }

  navigateToEdit(){
    this.enrollmentComponent.setCurrentStep(this.editPath.split('/').pop(), 'true');
    this.router.navigate([this.editPath], { relativeTo: this.route });
  }
}
